import styled from 'styled-components';
import { Layout } from 'antd';
import { maxWidth } from 'config/constants';

const { Header } = Layout;

export const StyledAppHeader = styled(Header)`
  &.ant-layout-header {
    background: ${(props): string => props.theme.kcc.colors.WHITE};
    height: auto;
    padding: ${(props): string => props.theme.kcc.spacing.SM}
      ${(props): number => props.theme.kcc.padding.CONTENT_HORIZONTAL}px
      ${(props): string => props.theme.kcc.spacing.MD};
    border-bottom: ${(props): number => props.theme.kcc.lineWidth.BORDER}px solid
      ${(props): string => props.theme.kcc.colors.BORDER};
    display: flex;
    flex-direction: column;
    gap: ${(props): string => props.theme.kcc.spacing.XXS};
  }

  .app-header__title {
    margin: 0;
    font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.BASE}px;
    font-family: ${(props): string => props.theme.kcc.typography.FONT_FAMILY};
    font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.BOLD};
    color: ${(props): string => props.theme.kcc.colors.TEXT};
    line-height: ${(props): number => props.theme.kcc.typography.LINE_HEIGHT.SM};
    height: 20px;
  }

  .app-header__row {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .app-header__section {
    flex: 1;
    display: flex;
    align-items: center;

    &--left {
      justify-content: flex-start;
    }

    &--center {
      justify-content: center;
    }

    &--right {
      justify-content: flex-end;
    }
  }

  .app-header__toggle {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${(props): string => props.theme.kcc.colors.TEXT};

    &:hover {
      opacity: 0.7;
    }

    &--mobile {
      display: none;
    }

    ${maxWidth.l} {
      &--desktop {
        display: none;
      }

      &--mobile {
        display: flex;
      }
    }
  }

  .app-header__toggle-icon {
    width: ${(props): number => props.theme.kcc.size.S300}px;
    height: ${(props): number => props.theme.kcc.size.S300}px;
    display: flex;
  }

  .app-header__logo {
    height: ${(props): number => props.theme.kcc.size.S500}px;
    width: auto;
    display: block;

    svg {
      height: ${(props): number => props.theme.kcc.size.S500}px;
      width: auto;
    }
  }
`;
